import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const FinancialConnectionProviderFieldsPlaidSchema = z
    .object({
        accessTokenId: z.string(),
        itemId: z.string(),
    })
    .strict();

export class FinancialConnectionProviderFieldsPlaid extends FromSchema(FinancialConnectionProviderFieldsPlaidSchema) {
    accessTokenId: string;
    itemId: string;
}
